import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-ui-not-authorized",
    templateUrl: "./not-authorized.component.html",
    styleUrls: ["./not-authorized.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotAuthorizedComponent {}
